import Vue from 'vue'
Array.prototype.remove = function(key,value){ // 删除对象数组中指定对象元素 key是对象元素的属性value是值
    for(let i=0; i<this.length; i++){
        if(this[i][key] === value){
            this.splice(i,1)
            break;
        }
    }
}
Array.prototype.unique = function(){ // 数组去重
    for (var i = 0; i < this.length-1; i++) {
        for(var j = i+1; j < this.length; j++){
            if(this[j] > this[i]){
                var temp = this[j];
                this[j] = this[j+1];
                this[j+1] = temp;
            }
        }
    }
}
Vue.prototype.losseJsonParse = function(str){ // 与eval功能相同 不用eval是因为性能浪费
    return Function('"use strict"; return ('+ str +')')()
}
Vue.prototype.getParents = function(el,number){ // 获取指定父级dom
    number = Number(number);
    if(number === 0) return el;
    let count = 1;
    let parent = el.parentNode
    while(count < number){
        count++;
        parent = parent.parentNode;
    }   
    return parent
}

Vue.prototype.debounce = function(func,delay = 200){ // 防抖
    let timeout = null
    return function () { // 闭包作用保存了timeout
        clearTimeout(timeout)
        timeout = setTimeout(() => {
            func.apply(this, arguments)
        }, delay)
    }
}
String.prototype.getQueryString = function(name){ // 获取url字符串参数值如：?id=123&name=456
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = this.substr(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return null;
}
